export default "__VITE_ASSET__2bcbb541__"